<template>
	<li v-if="sender === 'admin-sender'" class="admin-item">
		<div v-if="user !== null">
			<div class="message-meta">
				<span class="message-time">{{message.dateCreated | onlyTime}}</span>&nbsp;&middot;
				<span class="message-time-name">{{user.firstName}}</span>
			</div>
			<p class="message-body admin-sender">{{message.message}}</p>
		</div>
		<img v-if="userHasPhoto" :src="user.photoURL" />
		<no-user-image
			v-else
			:firstName="user.firstName"
			:lastName="user.lastName"
			:fontSize="11"
			:height="'25px'"
			:width="'25px'"
			class="no-user-image"
		></no-user-image>
	</li>
	<li v-else-if="sender === 'member-sender' && user !== undefined" class="member-item">
		<img v-if="userHasPhoto" :src="user.photoURL" />
		<no-user-image
			v-else
			:firstName="user.firstName"
			:lastName="user.lastName"
			:fontSize="11"
			:height="'25px'"
			:width="'25px'"
			class="no-user-image"
		></no-user-image>
		<div v-if="user !== null">
			<div class="message-meta">
				<span class="message-time-name">{{user.firstName}}</span>&nbsp;&middot;
				<span class="message-time">{{message.dateCreated | onlyTime}}</span>
			</div>
			<p class="message-body member-sender">{{message.message}}</p>
		</div>
	</li>
	<li v-else-if="sender === 'left-group'" class="activity-item">
		<div>
			<span>{{message.dateCreated | onlyTime}}</span>
			<p>{{message.sender.firstName}} left the group</p>
		</div>
	</li>
</template>

<script>
import NoUserImage from "../../errors/NoUserImage.vue";
import { getUser } from "../../../api/users";

export default {
    data() {
        return {
            user: null
        };
    },
    props: {
        message: {
            type: Object
        },
        members: {
            type: Array
        }
    },
    components: {
        NoUserImage
    },
    beforeMount() {
        this.getUser();
    },
    computed: {
        sender() {
            const authUser = this.$store.state.user.authUser.uid;

            if (this.message.type !== "leave") {
                if (this.message.senderID === authUser) {
                    return "admin-sender";
                } else {
                    return "member-sender";
                }
            } else {
                return "left-group";
            }
        },
        userHasPhoto() {
            if (
                this.user &&
                this.user.photoURL &&
                this.user.photoURL.length > 0
            ) {
                return this.user.photoURL;
            }
        }
    },
    methods: {
        async getUser() {
            this.user = this.members.find(
                member => member.userID === this.message.senderID
            );

            if (this.user !== undefined) {
                return this.user;
            } else {
                try {
                    this.user = await getUser(this.message.senderID);
                    return this.user;
                } catch (error) {
                    // console.log(error);
                    throw new Error(error);
                }
            }
        }
    }
};
</script>

<style scoped>
li {
    font-size: 12px;
    padding: 10px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    width: 70%;
}

.admin-item {
    justify-content: flex-end;
    float: right;
}

.member-item {
    justify-content: flex-start;
    float: left;
}

.activity-item {
    width: 100%;
    justify-content: center;
    color: grey;
}

.activity-item p {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0px 2px;
}

.activity-item p::before,
.activity-item p::after {
    content: "";
    height: 1px;
    background-color: grey;
    width: 100px;
}

.activity-item p::before {
    margin-right: 10px;
}

.activity-item p::after {
    margin-left: 10px;
}

.activity-item span {
    display: block;
    font-size: 8px;
    text-align: center;
}

img {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    object-fit: cover;
    align-self: flex-end;
}

.admin-sender {
    background-color: rgba(81, 199, 21, 0.34);
    margin-left: auto;
}

.admin-item img,
.admin-item .no-user-image {
    margin-left: 10px;
}

.member-sender {
    background-color: rgb(99, 99, 99);
}

.member-item img,
.member-item .no-user-image {
    margin-right: 10px;
}

.message-meta {
    padding-bottom: 2px;
}

.admin-item .message-meta {
    text-align: right;
}

.message-time {
    color: #b7b7b7;
    font-size: 8px;
    /* display: block; */
}

.message-time-name {
    color: #51c715;
    font-size: 10px;
    font-weight: bold;
}

.admin-item .message-time {
    text-align: right;
}

.message-body {
    border: none;
    border-radius: 10px;
    color: #fff;
    padding: 5px 10px;
    width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/groups/groupsMessage/GroupsMessageListItem.vue